import type { GetStreamingPackagesAdminResponse } from '@/backend/market'
import { mapEntityProperties } from '@/utils/mapEntityProperties'

import { LivePackageResponseEntity } from '../../domain/entities/LivePackageResponseEntity'
import { LivePackageModel } from './LivePackageModel'
export class LivePackageResponseModel extends LivePackageResponseEntity {
  constructor(dataDto: GetStreamingPackagesAdminResponse) {
    super()
    const livePackageModels = dataDto.packages?.map(
      (packageDto) => new LivePackageModel(packageDto)
    )
    mapEntityProperties<LivePackageResponseEntity>(this, dataDto, {
      exclude: ['packages'],
      map: {
        packages: livePackageModels
      }
    })
  }
}
